

















/* General */

/* Mixins */
import DashboardListMixin from '@/screens/dashboard/mixins/dashboard-list.mixin'

/* Components */

/* Helpers */

/* Data types */
import {
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogsDailyActivityLog,
} from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default DashboardListMixin.extend({
  props: {
    /**
     * View Type: Grid or Table
     */
    viewType: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    isSearching: {
      type: Boolean,
      required: true,
    },
    projects: {
      type: Array as () => IProjectsOutputProjectForHome[],
      required: true,
    },
    dailyActivityLogs: {
      type: Array as () => IProjectDailyActivityLogsDailyActivityLog[],
      default: null,
    },
  },
  methods: {
    async setFavorite(item: any) {
      if (item.isFavorite) {
        await InternalProjectsAPI.post_Favorite(item.id)
      } else {
        await InternalProjectsAPI.post_Unfavorite(item.id)
      }
    },

    async toggleFavorite(item: any) {
      try {
        // This will set the star on the item correctly since it's connected by ref...
        item.isFavorite = !item.isFavorite
        // This actually sets the update in the API...
        await this.setFavorite(item)
      } catch (error) {
        this.$error.emit(error, true)
      }
    },
  },

  computed: {
    accountID(): number {
      return parseInt(this.$route.params.accountId, 10)
    },
  },
})
